export default __webpack_public_path__ + "static/media/3.4481322a.jpg";